<template>
	<slot></slot>
</template>

<script setup lang="ts">
import {connectEventBus} from "@fd/Environment.ts";

const props = defineProps<{
	name: string;
}>();
connectEventBus(props.name);
</script>

<style>

</style>